<mat-chip-list>
                <mat-chip [ngStyle]="getStatusStyle()"> {{ getStatusLabel() }}</mat-chip>
              </mat-chip-list>